module.exports = __webpack_public_path__ + "static/img/s6.2fbbcd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/s6.png
// module id = Msdg
// module chunks = 1